module.exports = __webpack_public_path__ + "media/honey-icons/icon-close-white-6b3c97a7.svg";